import { SecureAttachmentForm } from "./add-file"

export const initialFormState = (): SecureAttachmentForm => {
  return {
    file: null,
    fileName: '',
    displayName: '',
    description: ''
  }
}